import {
	type Control,
	Controller,
	type FieldPathByValue,
	type FieldValues,
} from "react-hook-form";
import { FolderPicker } from "web_myplann/Portfolio/Components/Redesign/Documents/FolderPicker";

type Props<
	FormType extends FieldValues,
	TContext,
	TTransformed extends FieldValues | undefined,
> = {
	control: Control<FormType, TContext, TTransformed>;
	name: FieldPathByValue<FormType, string | null>;
	label: string;
	placeholder: string;
	folders: string[];
	isLast?: boolean;
};

export const FolderFormPicker = <
	FormType extends FieldValues,
	TContext = unknown,
	TTransformed extends FieldValues | undefined = undefined,
>({
	control,
	name,
	...rest
}: Props<FormType, TContext, TTransformed>) => (
	<Controller
		control={control}
		name={name}
		render={({ field: { value, onChange } }) => (
			<FolderPicker {...rest} value={value} onChange={onChange} />
		)}
	/>
);
